// $.fn.articleColumns = function () {
$.articleColumns = function () {
  jQuery(document).ready(function ($) {
    $(':not(.col-2) + .col-2, * > .col-2:first-of-type').each(function () {
      $(this).nextUntil(':not(.col-2)').addBack().wrapAll('<div class="columns" />');
    });
    $(':not(.col-3) + .col-3, * > .col-3:first-of-type').each(function () {
      $(this).nextUntil(':not(.col-3)').addBack().wrapAll('<div class="columns" />');
    });
    $(':not(.col-4) + .col-4, * > .col-4:first-of-type').each(function () {
      $(this).nextUntil(':not(.col-4)').addBack().wrapAll('<div class="columns" />');
    });
    $(':not(.col-5) + .col-5, * > .col-5:first-of-type').each(function () {
      $(this).nextUntil(':not(.col-5)').addBack().wrapAll('<div class="columns" />');
    });
    $(':not(.col-6) + .col-6, * > .col-6:first-of-type').each(function () {
      $(this).nextUntil(':not(.col-6)').addBack().wrapAll('<div class="columns" />');
    });

    //When Isolated Images are being used
    //Isolated Images inside Columns JS - If first column contains an isolated image, then reverse the row
    $('.columns > .column.isolated-image:first-child').each(function () {
      $(this).parent().addClass('row-reverse');
    });

    //If Isolated Image is being used, check the height and set height as minimum height to parent
    function setColumnsMinHeight() {
      $('.column.isolated-image img').each(function () {
        var imgHeight = $(this).height();
        // set the minimum height of the parent element to the image height
        $(this).closest('.columns').css('min-height', imgHeight - 160);
        $(this).closest('.block-container').css('min-height', imgHeight);
      });
    }
    setColumnsMinHeight();
    //Call setColumnsMinHeight on window resize
    $(window).resize(setColumnsMinHeight);

    //END - Isolated Images being used

  });
}